function LocationStatus(status, statusText) {
  this.status = status;
  this.statusText = statusText;
}

LocationStatus.prototype = {
  status: '',
  statusText: ''
};

module.exports = LocationStatus;
